import React, { useContext, useState, useEffect } from 'react';
import "../../../ui-styles/list/CardsList.css";
import { LangCtx } from "../../../lib/context";

import ApprovedAppointmentsItem from "./approvedAppointmentsItem";
import { appointmentList, getWaitingRoomList } from "../../../actions/appointment";
import Loader from "../../../lib/ui/loader/Loader";
import NoData from "../../../lib/ui/nodata/NoData";
import {API} from 'aws-amplify';

const ConsultationRoom = (props) => {
    const { l } = useContext(LangCtx);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [wrlist, setWRList] = useState([]);
    useEffect(() => {
        loadData();
        getWaitingRoomList().then(res => {
            if (res.status) {
                props.updateWrCount()
                setWRList([...res.data])
            } else {
                setWRList([])
            }
        }).catch(err => {
            console.log("err ==== ", err);
            setWRList([])
        })
    }, []);

    const loadData = () => {
        setLoading(true);
        let _f = new Date();
        let _t = new Date();
        // _f.setHours(0, 0, 0, 0);
        _t.setHours(23, 59, 59, 99);
        _t.setMinutes(_t.getMinutes() + 30)
        appointmentList("doctor", ["confirmed"], _f.valueOf(), _t.valueOf(), "UA").then(res => {
            setLoading(false);
            res && res.status ? setData([...res.data]) : setData(null);
        }).catch(err => {
            console.log("err ===== ", err);
            setData(null);
            if(API.isCancel(err)) {
                console.log("API is canceled................");
            } else {
                setLoading(false);
            }
        })
    }

    return (
        <div className="listContainer pos-rel">
            <div className="listTxtInfo">
                <span>{l.waitingTxt}</span>
            </div>
            <div className="cardBlock">
                <div className="cardContainer">
                    {loading && <Loader />}
                    {data && data.length > 0 ?
                            data.map(item => {
                                let writem = wrlist.filter(wr => wr.apptId === item.appointmentId);
                                return <ApprovedAppointmentsItem updateWrCount={props.updateWrCount} data={item} key={item.appointmentId} wrdata={writem && writem[0] ? writem[0] : null} loadData={loadData} />
                            })
                            : !loading && <NoData Heading={l.no_patients} src="/images/icons/waiting-room.png" label='' />}
                </div>
            </div>
        </div>
    )
}

export default ConsultationRoom;